<script lang="ts">
  import FizzStyles from "@shared/svelte/Components/FizzStyles.svelte";
  import Message from "@shared/svelte/Components/Flash/Message.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";

  export let onBlockCallback: any;
  let showStatus = false;
  let message = {
    dismissible: false,
    compact: false,
    rawHtml: false,
    type: "info",
    header: "You opted out of text notifications",
    message: 'To opt back in, please text "unstop" to 1 (855) 574-0691',
  };

  const fetchSMSBlockedAndShowAlert = async () => {
    const res = await HttpPromise({
      method: "GET",
      url: "/api/distributor/notifications/sms_blocked",
    });
    showStatus = res.blocked;
    if (showStatus && onBlockCallback) onBlockCallback();
  };
  fetchSMSBlockedAndShowAlert();
</script>

{#if showStatus}
  <FizzStyles>
    <div class="fizz-stack-8" data-testid="phone-notifications-opted-out-status">
      <Message {message} />
    </div>
  </FizzStyles>
{/if}
